<script>
import fadeIn from '../components/animations/FadeIn.vue';
import fadeInUp from '../components/animations/FadeInUp.vue';
import magnetic from '../components/Magnetic.vue';
import wavyLine from '../components/wavy-line.vue';

export default {
    components: {
        fadeIn,
        fadeInUp,
        magnetic,
        wavyLine
    },

    mounted() {
        this.waveRide();
    },

    methods: {
        waveRide() {
            gsap.fromTo(
                this.$refs.wave,
                { yPercent: -15 },
                {
                    duration: 1,
                    yPercent: 75,
                    ease: 'none',
                    scrollTrigger: { trigger: this.$refs.container, scrub: 1 }
                }
            );
        }
    }
};
</script>
